import React, { useState, useRef, useContext } from 'react';

// ------------------ COMPONENTES DE PRIMEREACT --------------------------
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { OverlayPanel } from 'primereact/overlaypanel';

// ------------------ COMPONENTES DE BASE --------------------------------
import AgGrid from '../../../../../../Base/Components/Tables/AgGrid/AgGrid';
import Loader from '../../../../../../Base/Components/Loader/Loader';
import { AuthContext } from '../../../../../../Base/Context/AuthContext/AuthContext';

// ------------------- CONSULTAS A LA API --------------------------------
import { getProveedorCAIporVendor } from '../../../../../../API/Compras/Proveedores/ProveedoresCAIRequest';

// ------------------ COMPONENTES DE NECESARIOS --------------------------
import CrudProveedoresCAI from '../../../../Compras/Proveedores/ModalProveedores/CrudProveedoresCAI';

const OverlayProveedorCAI = ({ IdProveedor, values, onChange, close, habilitar }) => {

    const op = useRef(null);
    const buttom = useRef(null)
    const [loading, setLoading] = useState(false);
    const [proveedoresCAI, setProveedoresCAI] = useState([]);
    const [showDialog, setShowDialog] = useState(false);

    const { userAuth } = useContext(AuthContext)

    const obtenerProveedoresCAI = async () => {
        setLoading(true)
        if (IdProveedor > 0) {
            const result = await getProveedorCAIporVendor(IdProveedor)
            setProveedoresCAI(result)
        }
        setLoading(false)
    }

    const colums = [
        {
            field: 'IdProveedorCAI',
            header: 'IdProveedorCAI',
            headerEn: 'IdProveedorCAI',
            className: 'Xsmall',
            hidden: userAuth.IdRol === 1,
            frozen:true,
            alignFrozen:'left'
        },
        {
            field: 'NombreSucursal',
            header: 'Nombre Sucursal',
            headerEn: 'Sucursal Name',
            className: 'XXlarge',
            Sumary: 'count',
            frozen:true,
            alignFrozen:'left'
        },
        {
            field: 'Prefijo',
            header: 'Prefijo',
            headerEn: 'Prefijo',
            className: 'small',
        },
        {
            field: 'NoCAI',
            header: 'CAI',
            className: 'XXXlarge',
            flex: 1,
        },
        {
            field: 'FechaVencimiento',
            header: 'Fecha Vencimiento',
            headerEn: 'Expired Date',
            className: 'small',
            Format: 'Date',
        },
        {
            field: 'StatusName',
            header: 'Estado',
            headerEn: 'Status',
            className: 'Xsmall',
            Format: 'Estado',
            body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.StatusName }),
        },
        {
            field: 'RangoInicial',
            header: 'Rango Inicial',
            headerEn: 'Rango Inicial',
            className: 'Xsmall',
        },
        {
            field: 'RangoFinal',
            header: 'Rango Final',
            headerEn: 'Rango Final',
            className: 'Xsmall',
        },

    ]

    const table = {
        Data: proveedoresCAI,
        Columns: colums,
        onCellClicked: e => onChange(e, op)
    }

    const openOver = (e) => {
        op.current.toggle(e)
        setLoading(true)
        obtenerProveedoresCAI()
    }

    return (
        <div style={{ maxWidth: '55vw' }}>

            <div className="p-inputgroup">
                <Button ref={buttom} icon='pi pi-chevron-down' type="button" onClick={(e) => openOver(e)} disabled={!habilitar} />
            </div>

            <OverlayPanel ref={op} showCloseIcon dismissable={false} onHide={close} style={{ height: '36vh', width: '68vw' }} >
                <Loader loading={loading} querySelector={'#ProveedoresCAIS'} />
                <div className='d-flex gap-2'>
                    <Button icon='pi pi-refresh' type="button" onClick={(e) => obtenerProveedoresCAI()} />
                    <Button
                        icon="pi pi-plus"
                        type="button"
                        disabled={!IdProveedor || IdProveedor <= 0}
                        onClick={() => setShowDialog(true)}
                    />
                </div>
                <div style={{ width: '65vw', height: '30vh', marginTop: 6 }} id='ProveedoresCAIS'>
                    <AgGrid table={table} />
                </div>
            </OverlayPanel>


            <Dialog
                visible={showDialog}
                onHide={() => setShowDialog(false)}
                maximizable
                closeOnEscape={false}
            >
                <CrudProveedoresCAI
                    showDialog={showDialog}
                    setShowDialog={setShowDialog}
                    IdProveedor={IdProveedor}
                    actualizarProveedoresCAI={obtenerProveedoresCAI}
                />
            </Dialog>
        </div>
    )
}

export default OverlayProveedorCAI